import { useResponsiveProp } from "@shopify/restyle";

import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import { HStack, VStack } from "@whoosh/design-system/src/components/primitive";

export const AvailabilityListSkeleton = () => {
  const rowsToDisplay = useResponsiveProp({ base: 1, lg: 2 }) || 1;
  const numOfColumns = 4;
  const rows = Array.from({ length: rowsToDisplay });
  const columns = Array.from({ length: numOfColumns });
  return (
    <VStack gap={2}>
      {rows.map((_, i) => (
        <HStack gap={2} px={6} flex={1} key={i}>
          {columns.map((_, j) => {
            return (
              <SkeletonLoader
                key={j}
                height={60}
                minWidth={152}
                borderRadius="2"
                flexBasis="24%"
              />
            );
          })}
        </HStack>
      ))}
    </VStack>
  );
};
